import moment from 'moment';
import 'moment/locale/nb';

moment.locale('nb');

export default moment;
